<div class="container-fluid">
    <div class="row m-0 p-1 w-100">
        <div class="col-lg-12 m-0 p-1">
            <div class="bg-white rounded shadow">
                <form [formGroup]="filterform">

                    <div class="row m-0 header-filter">
                   
                        <div class="col-md-2 d-flex my-auto">
                            <div class="my-auto ml-1 mr-2" *ngIf="nSubModule==2 || nSubModule==3 || nSubModule==4">
                                <div class="back pointer">
                                    <a (click)="onBackClick();"><i class="fa fa-long-arrow-left fa-lg"></i></a>
                                </div>
                            </div>
                            <div class="custom-search form-group my-auto" >
                                <input type="filter" formControlName="search" (keyup)="doSearch(term)" class="custom-search-input" placeholder="Search for" autocomplete="off" tabindex="1" [(ngModel)]="term">
                            </div>
                        </div>
                        <div class="col-md-8 row my-auto" >
                        
                            <ng-multiselect-dropdown class="col-sm select-cstyle" 
                                [placeholder]="'All Assets'"
                                [settings]="dropdownSettings" formControlName="asset_type_id"
                                [data]="AssetsDataLists"
                                (onSelect)="onItemSelect($event)"
                                (onDeSelect)="onItemDeSelect($event)"
                                (onSelectAll)="onSelectAll()"
                                (onDeSelectAll)="onDeSelectAll()">
                            </ng-multiselect-dropdown>
    
                            <ng-multiselect-dropdown class="col-sm select-cstyle"
                                [placeholder]="'All Creatives'"
                                [settings]="dropdownSettings"
                                [data]="CreativeDataLists"
                                formControlName="creative_id"
                                (onSelect)="onCreativeItemSelect($event)"
                                (onDeSelect)="onCreativeItemDeSelect($event)"
                                (onSelectAll)="onCreativeSelectAll()"
                                (onDeSelectAll)="onCreativeDeSelectAll()">
                            </ng-multiselect-dropdown>
    
                            <ng-multiselect-dropdown class="col-sm select-cstyle"
                                [placeholder]="'All Vendors'"
                                [settings]="dropdownSettings"
                                [data]="VendorDataLists"
                                formControlName="vendor_id"
                                (onSelect)="onVendorItemSelect($event)"
                                (onDeSelect)="onVendorItemDeSelect($event)"
                                (onSelectAll)="onVendorSelectAll()"
                                (onDeSelectAll)="onVendorDeSelectAll()">
                             </ng-multiselect-dropdown>

                        </div>
                        <div class="col-md-2 d-flex my-auto justify-content-end" >
                            <div class="">    
                                <button class="btn btn-reset align-items-center" (click)="clearFilters()"><u>Reset filter</u></button>
                            </div> 
                        </div>
                        
                    </div>
                </form>
            </div>
        </div>
    </div>
    
    <div class="row m-0 p-1"  *ngIf="nSubModule==1">     
        <div class="col-md-4 m-0 p-1" *ngIf="is_Admin_User">
            <div class="bg-white rounded shadow pb-3">
                <div class="p-2" *ngIf="isShowTab">
                    <!-- Rounded tabs -->
                    <ul id="myTab" role="tablist" class="nav nav-tabs nav-pills flex-column flex-sm-row text-center bg-light border-0 rounded-nav">
                        <li class="nav-item flex-sm-fill">
                        <a id="state-tab" data-toggle="tab" href="#state" role="tab" aria-controls="state" aria-selected="true" class="nav-link border-0 text-uppercase font-weight-bold active">Region</a>
                        </li>
                        <li class="nav-item flex-sm-fill">
                        <a id="showroom-tab" data-toggle="tab" href="#showroom" role="tab" aria-controls="showroom" aria-selected="false" class="nav-link border-0 text-uppercase font-weight-bold">Showroom</a>
                        </li>
                    </ul>            
                    <!-- End rounded tabs -->
                </div>
                <div id="myTabContent" class="tab-content regionShowroomLists"  *ngIf="isShowTab">
                    <div id="state" role="tabpanel" aria-labelledby="state-tab" class="tab-pane fade px-1 show active">
                        <div class="row justify-content-center mp-0">
                            <div class="col-md-6 my-1 mx-auto" *ngFor="let data of RegionDataLists;let i=index">
                                <div class="box p-1 pointer text-center" (click)="onRegionClick(data.id,data.name)">
                                    <img class="img-fluid w-100 z-depth-1"
                                    onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                    alt="">
                                    <p class="text-center text-black text-break text-uppercase m-0 p-2 font-weight-bold">{{data.name}}</p>
                                </div>
                            </div>
                            <div class="text-center p-3" *ngIf="RegionDataLists && RegionDataLists.length === 0" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                </svg>
                                <p class="m-0 p-4 no-record"> No Record Found </p>
                            </div>
                        </div>
                    </div>
                    <div id="showroom" role="tabpanel" aria-labelledby="showroom-tab" class="tab-pane fade px-1">
                        <div class="row justify-content-center mp-0">
                            <div class="col-md-6 my-1 mx-auto" *ngFor="let data of ShowroomDataLists;let i=index">
                                <div class="box p-1 pointer text-center" (click)="showHoardingData(data.region_id,data.regionName,data.id,data.name)">
                                    <img class="img-fluid  w-100  z-depth-1"
                                    onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                    alt="">
                                    <p class="text-center text-black text-break text-uppercase font-weight-bold m-0 p-2">{{data.name}}</p>
                                </div>
                            </div>
                            <div class="text-center p-3" *ngIf="ShowroomDataLists && ShowroomDataLists.length === 0" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                </svg>
                                <p class="m-0 p-4 no-record"> No Record Found </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=""  *ngIf="!isShowTab">
                    <div class="title-header d-flex">
                        <div class="text-right col-3 my-auto">
                            <div class="back pointer">
                                <a (click)="onBackClick();"><i class="fa fa-long-arrow-left fa-lg"></i></a>
                            </div>
                        </div>
                        <div class="text-left col-9 my-auto">
                            <span class="text-muted">Region : </span><h5 class="m-0 p-0">{{selected_region_name}}</h5>
                        </div>
                    </div>
                    <div class="regionShowroomLists row justify-content-center m-0 p-0">
                        <div class="col-6 my-1 mx-auto" *ngFor="let data of f_Region_Showroom_list;let i=index">
                            <div class="box p-1 pointer text-center" (click)="showHoardingData(data.region_id,data.regionName,data.id,data.name)">
                                <img class="img-fluid  w-100 z-depth-1"
                                onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}"
                                alt="">
                                <p class="text-center text-black text-break text-uppercase m-0 p-2 font-weight-bold">{{data.name}}</p>
                            </div>
                        </div>

                        <div class="text-center p-3" *ngIf="f_Region_Showroom_list && f_Region_Showroom_list.length === 0" >
                            <p class="m-0 p-4 no-record"> No Record Found </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="is_Admin_User ? 'col-md-8' : 'col-md-12'" class="m-0 p-1">
            <div class="bg-white rounded shadow">
                <div class="title-header"><h5 class="mp-0">Hoardings</h5></div>
                    <div class="p-2">
                        <div class="box-table  expiry-table hoarding table-responsive p-2">
                            <table class="table box-table table-borderless m-0 p-0">
                                <thead class="">
                                    <tr class="justify-content-center ">
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Expiry Days</p></th>
                                        <th class="text-center"><p class="m-0">Region</p></th>
                                        <th class="text-center"><p class="m-0">Showroom</p></th>
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Area</p></th>
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Address</p></th>
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Type</p></th>
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Creative</p></th>
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Vendor</p></th>
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Name</p></th>
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Size</p></th>
                                        <!-- <th class="text-center" mat-sort-header = ""><p class="m-0">Sq. Feet</p></th> -->
                                        <th class="text-center" mat-sort-header = ""><p class="m-0">Cost</p></th>
                                    </tr>
                                
                                </thead>
                                <tbody class="">
                                    <tr class="pointer" *ngFor="let data of FilteredHoardingExpiredLists| filter:term| slice: (page-1) * pageSize : page * pageSize;let i=index" (click)="showHoardingDetails(data)">
                                        <td class="text-center"><p class="m-0 font-weight-bold"  [ngStyle]="{'color':getColor(data?.expiryDays)}">{{data.expiryDays}}</p></td>
                                        <td class="text-center"><p class="m-0">{{data.regionName}}</p></td>
                                        <td class="text-center"><p class="m-0">{{data.showroomName}}</p></td>
                                        <td class="text-center"><p class="m-0 p-0">{{data.area}}</p></td>
                                        <td class="text-center"><p class="m-0 p-0">{{data.address}}</p></td>
                                        <td class="text-center"><p class="m-0">{{data.assetTypeName}}</p></td>
                                        <td class="text-center"> <p class="m-0">{{data.creativeName}}</p></td>
                                        <td class="text-center"><p class="m-0">{{data.vendorName}}</p></td>
                                        <td class="text-center"><p class="m-0">{{data.name}}</p></td>
                                        <td class="text-center"><p class="m-0">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p>
                                        <td class="text-center"><p class="m-0">{{data.cost| currency:'INR'}}</p></td>
                                    </tr>
                                </tbody> 
                            
                            </table>
                            <div class="text-center p-5" *ngIf="FilteredHoardingExpiredLists && FilteredHoardingExpiredLists.length === 0" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                                    <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                                </svg>
                                <p class="m-0 no-record"> No Record Found </p>
                            </div>
                        </div>
                    </div>
                <div class="mt-1 sl-pagination text-center justify-content-center d-flex" *ngIf="FilteredHoardingExpiredLists && FilteredHoardingExpiredLists.length > 10">
                    <ngb-pagination  [(page)]="page"  [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true" 
                    [pageSize]="pageSize"
                    [collectionSize]="FilteredHoardingExpiredLists.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
                </div>
            </div>
           
            <div class="col-lg-12 row w-100 mp-0">
                <div class="col-md-5 p-2 ">
                    <div class="d-flex  parent-box mt-2">
                        <div class="box-instore shadow pointer" (click)="loadExpiredData(1)">
                            <div class="top-solid solid-green d-flex justify-content-center align-items-center" *ngIf="nExpiredAll">
                                {{nExpiredAll.length}}
                            </div>  
                            <div class="label-value d-flex justify-content-center align-items-center text-center">
                                <p>All</p>
                            </div>  
                        </div>
                        <div class="box-instore shadow pointer" (click)="loadExpiredData(0)">
                            <div class="top-solid solid-red d-flex justify-content-center align-items-center" *ngIf="nExpired0">
                                {{nExpired0.length}}
                            </div>  
                            <div class="label-value d-flex justify-content-center align-items-center text-center">
                                <p>Expired</p>
                            </div>  
                        </div>
                        <div class="box-instore shadow pointer" (click)="loadExpiredData(10)">
                            <div class="top-solid solid-orange d-flex justify-content-center align-items-center" *ngIf="nExpiredNot">
                                {{nExpiredNot.length}}
                            </div>  
                            <div class="label-value d-flex justify-content-center align-items-center text-center">
                                <p>Not Expired</p>
                            </div>  
                        </div>
                        
                    </div>
                </div>
                <div class="col-md-7 p-2 "> 
                    <div class="bg-white rounded shadow">
                        <div class="title-header"><h5 class="mp-0">Unchanged Ads</h5></div>
                        <div class="table-responsive p-2">
                            <table class="table table-borderless m-0 p-0">
                                <thead class="">
                                    <tr class="justify-content-center ">
                                        <th class="text-center"><p class="m-0">10 Days</p></th>
                                        <th class="text-center" ><p class="m-0">30 Days</p></th>
                                        <th class="text-center" ><p class="m-0">6 Months</p></th>
                                        <th class="text-center" ><p class="m-0">2 Years</p></th>
                                        <th class="text-center" ><p class="m-0">5 Years</p></th>
                                    </tr>
                                </thead>
                
                                <tbody class="">
                                    <tr class="">
                                        <td class="text-center"><p class="m-0">{{nUnchange10}}</p></td>
                                        <td class="text-center"><p class="m-0">{{nUnchange30}}</p> </td>
                                        <td class="text-center"> <p class="m-0">{{nUnchange180}}</p></td>
                                        <td class="text-center"><p class="m-0">{{nUnchange720}}</p></td>
                                        <td class="text-center"><p class="m-0">{{nUnchange1825}}</p></td>

                                    </tr>
                                </tbody> 
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-0 p-1"  *ngIf="nSubModule==2">
        <div class="col-lg-12 m-0 p-1">
            <div class="bg-white rounded shadow pb-3 gallery-image">
                <div class="row m-0 p-2  d-flex">
                    <p class="m-0 p-0 img-grid-header">{{selected_region_name}}&nbsp;&nbsp;&#187;&nbsp;&nbsp;</p>
                    <p class="m-0 p-0 img-grid-header">{{selected_showroom_name}}</p>
                    <!-- <div *ngIf="!selAssetTypeValue.isNaN"><p class="m-0 p-0 img-grid-header">&nbsp;&nbsp;&#187;&nbsp;&nbsp;{{selectedAssetTypeName}}</p></div>
                    <div *ngIf="!selCreativeValue.isNaN"><p class="m-0 p-0 img-grid-header" >&nbsp;&nbsp;&#187;&nbsp;&nbsp;{{selectedCreativeName}}</p></div>
                    <div *ngIf="!selVendorValue.isNaN"><p class="m-0 p-0 img-grid-header" >&nbsp;&nbsp;&#187;&nbsp;&nbsp;{{selectedVendorName}}</p></div> -->

                </div>
                <div class="img-grid mb-4 pointer p-1">
                    <div class="img-box p-1" *ngFor="let data of filtered_detail_HoardingsLists| filter:term;let i=index " (click)="showDetailedView(data.id,data.name)">
                        <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}" onerror="this.src='/assets/grt.svg'" alt=""/>
                        <div class="p-2">
                            <div class="d-flex"><p class="img-grid-title">Type&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.assetTypeName}}</p></div>
                            <div class="d-flex"><p class="img-grid-title">Creative&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.creativeName}}</p></div>   
                            <div class="d-flex"><p class="img-grid-title">Size&nbsp;:&nbsp;</p><p class="img-grid-content">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p></div>
                            <div class="d-flex"><p class="img-grid-title">Sqft&nbsp;:&nbsp;</p><p class="img-grid-content">{{splitNumber(data.size_w * data.size_h)}}</p></div>
                            <div class="d-flex"><p class="img-grid-title">Vendor&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.vendorName}}</p></div>
                            <div class="d-flex"><p class="img-grid-title">Area&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.address}}</p></div>   
                        </div>  
                        <div class="row m-0" *ngIf="data.expiryDays <0 ">
                            <div class="ribbon">Expired ({{data?.expiryDays}} Days)</div>                   
                        </div>
                        <div class="row m-0" *ngIf="data.expiryDays >=0 && data.expiryDays <=30">
                            <div class="ribbon-e">Expiring in ({{data?.expiryDays}} Days)</div>                   
                        </div>
                    </div>
                    
                  
                </div> 
                <div class="text-center p-3" *ngIf="filtered_detail_HoardingsLists && filtered_detail_HoardingsLists.length === 0" >
                    <p class="m-0 no-record"> No Record Found </p>
                </div>
            </div>
        </div>
    </div>
    
    <div class="row m-0 p-1"  *ngIf="nSubModule==3">
        <div class="m-0 p-1" [ngClass]="{'col-lg-5':isLog, 'col-lg-8':!isLog}">
            <div class="bg-white rounded shadow pb-3 floor-image">
                <div class="col-lg-12 row mp-0 w-100">
                    <div class="col-6 m-0 p-0">
                        <div class="d-flex m-0 p-2 pointer" *ngIf="is_Admin_can_Edit">
                            <input type="checkbox" id="checkAll"  name="checkAll"  [checked]="isAllHoardingsChecked" class="m-1" (click)="checkAll()">
                            <label class="m-0 p-0 my-auto" for="checkAll" data-content=""> 
                                <p class="m-0 p-0 select-title">Select / Unselect all<span class="img-grid-title"> ( {{isAllHoardingsChecked === true ? 'All Selected' : selectedHoarding_Lists.length+' Selected'}} )</span></p></label>
                        </div>
                    </div>
                    <div class="col-6 m-0 p-2">
                        <div class="d-flex justify-content-end detail-buttons p-1" *ngIf="selectedHoarding_Lists?.length > 1">
                            <button type="button" class="btn btn-success mr-2" (click)="bulkUpdateModify(true)">Save Changes</button>
                            <!-- <button type="button" class="btn btn-dark" (click)="bulkUpdateModify(false)">Modify</button> -->
                        </div>
                    </div>
                </div>
                <div  class="regionShowroomLists m-0 p-0">
                    <div class="img-grid-container p-2 mb-4 pointer">
                        <div class="img-box" *ngFor="let data of filtered_detail_HoardingsLists| filter:term;let i=index" [ngStyle]="{'background-color': selectedHoarding_ID === data.id ? '#fcb626' : '#FEF8EB' }">
                            <div class=""  (click)="clickHoarding(data.id,data.name)"> 
                                <div class="row m-0" *ngIf="data.expiryDays <0 ">
                                    <div class="ribbon">Expired ({{data?.expiryDays}} Days)</div>                   
                                </div>
                                <div class="row m-0" *ngIf="data.expiryDays >=0 && data.expiryDays <=30">
                                    <div class="ribbon-e">Expiring in ({{data?.expiryDays}} Days)</div>                   
                                </div>
                                <div class="text-center">
                                    <img  onerror="this.src='/assets/grt.svg'" src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{data.image}}" alt=""  />
                                </div>
                                <div class="p-2">
                                    <div class="d-flex"><p class="img-grid-title">Type&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.assetTypeName}}</p></div>
                                    <div class="d-flex"><p class="img-grid-title">Creative&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.creativeName}}</p></div>   
                                    <div class="d-flex"><p class="img-grid-title">Size&nbsp;:&nbsp;</p><p class="img-grid-content">W {{splitNumber(data.size_w)}} x H {{splitNumber(data.size_h)}}</p></div>
                                    <!-- <div class="d-flex"><p class="img-grid-title">Sqft&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.size_w * data.size_h}}</p></div> -->
                                    <div class="d-flex"><p class="img-grid-title">Cost&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.cost| currency:'INR'}}</p></div> 
                                    <div class="d-flex"><p class="img-grid-title">Vendor&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.vendorName}}</p></div>
                                    <div class="d-flex"><p class="img-grid-title">Area&nbsp;:&nbsp;</p><p class="img-grid-content">{{data.address}}</p></div>   
                                </div>
                            </div>
                            <div class="text-right" *ngIf="is_Admin_User">
                                <input class="checkbox" id="checkFollower" type="checkbox" [checked]="data.isChecked" (change)="setChecked(data.id)">
                            </div>
                        </div>
                    </div> 
                  
                    <div class="text-center p-3" *ngIf="filtered_detail_HoardingsLists && filtered_detail_HoardingsLists.length === 0" >
                        <p class="m-0 no-record"> No Record Found </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="m-0 p-1" [ngClass]="{'col-lg-7':isLog, 'col-lg-4':!isLog}">
            <div class="bg-white rounded shadow">
                <div class="row m-0 p-2 d-flex">
                    <p class="m-0 p-0 img-grid-title">{{selected_region_name}}&nbsp;&nbsp;&#187;&nbsp;&nbsp;</p>
                    <p class="m-0 p-0 img-grid-title">{{selected_showroom_name}}</p>
                </div>
                <div class="title-header"><h5 class="mp-0">{{nameHoarding}}</h5></div>
                <div class="row mp-0 w-100"> 
                    <div class="col p-1 m-0" *ngIf="isLog"> 
                        <div class="box-table shadow">
                            <div class="card-title text-center p-1">Previous</div>
                            <div class="mx-auto text-center">
                                <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{hoardingPreviousData?.image}}" onerror="this.src='/assets/grt.svg'" class="detailed-img p-2">
                            </div>
                            <div class="details-info px-3">
                                <div class="form-group row">
                                    <div class="col-4"><p>Installation Date</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.install_date}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Expiry Date</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.expiry_date}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Name</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.name}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 "><p>Region</p></div>
                                    <div class="col-8 "><p>{{hoardingPreviousData?.regionName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4 "><p>Showroom</p></div>
                                    <div class="col-8 "><p>{{hoardingPreviousData?.showroomName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Area</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.address}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Asset Type</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.assetTypeName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Creative</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.creativeName}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Size</p></div>
                                    <div class="col-8">
                                        <p class="mp-0">Width  :  {{splitNumber(hoardingPreviousData?.size_w)}}</p>
                                        <p class="mp-0">Height :  {{splitNumber(hoardingPreviousData?.size_h)}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Square feet</p></div>
                                    <div class="col-8">
                                        <p class="mp-0">{{splitNumber(hoardingPreviousData?.size_w * hoardingPreviousData?.size_h)}}</p>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Cost</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.cost| currency:'INR'}}</p></div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4"><p>Particulars</p></div>
                                    <div class="col-8"><p>{{hoardingPreviousData?.particulars}}</p></div>
                                </div>
                            </div>  
                        </div>
                      
                    </div>
                    <div class="col p-1 m-0">
                        <div class="box-table shadow"> 
                            <div class="navbarheader m-0 p-0">
                                <div class="header-title card-title p-1">Current</div>
                                <div *ngIf="is_Admin_can_Edit">
                                    <div class='header-right icon social print mt-1 mr-2' *ngIf="!isEdit" ngbTooltip="Edit" (click)="editHoarding()"><i class='fa fa-pencil'></i></div>
                                    <div class='header-right icon social print mt-1 mr-2' *ngIf="isEdit" ngbTooltip="Cancel" (click)="cancelEditHoarding()"><i class='fa fa-ban'></i></div>
                                </div>
                            </div>
                            <div class="" *ngIf="!isEdit">
                                <div class="mx-auto text-center">
                                    <img src="https://brandmonitoringapp.grtjewels.com/api/uploads/{{hoardingCurrentData?.image}}" onerror="this.src='/assets/grt.svg'" class="detailed-img p-1">
                                </div>
                                <div class="details-info px-3" >
                                    <div class="form-group row">
                                        <div class="col-4"><p>Installation Date</p></div>
                                        <div class="col-8"><p>{{hoardingCurrentData?.install_date| date: 'dd/MM/yyyy'}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Expiry Date</p></div>
                                        <div class="col-8"><p>{{hoardingCurrentData?.expiry_date| date: 'dd/MM/yyyy'}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Name</p></div>
                                        <div class="col-8"><p>{{hoardingCurrentData?.name}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 "><p>Region</p></div>
                                        <div class="col-8 "><p>{{hoardingCurrentData?.regionName}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4 "><p>Showroom</p></div>
                                        <div class="col-8 "><p>{{hoardingCurrentData?.showroomName}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Area</p></div>
                                        <div class="col-8"><p>{{hoardingCurrentData?.address}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Asset Type</p></div>
                                        <div class="col-8"><p>{{hoardingCurrentData?.assetTypeName}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Creative</p></div>
                                        <div class="col-8"><p>{{hoardingCurrentData?.creativeName}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Size</p></div>
                                        <div class="col-8">
                                            <p class="mp-0">Width : {{splitNumber(hoardingCurrentData?.size_w)}}</p>
                                            <p class="mp-0">Height :  {{splitNumber(hoardingCurrentData?.size_h)}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Square feet</p></div>
                                        <div class="col-8">
                                            <p class="mp-0">{{splitNumber(hoardingCurrentData?.size_w * hoardingCurrentData?.size_h)}}</p>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Cost</p></div>
                                        <div class="col-8"><p>{{hoardingCurrentData?.cost| currency:'INR'}}</p></div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-4"><p>Particulars</p></div>
                                        <div class="col-8"><p> {{hoardingCurrentData?.particulars}}</p></div>
                                    </div>
                                    <!-- <div class="form-group row">
                                        <div class="col-4"><p>Status</p></div>
                                        <div class="col-8"><p>{{getExipreName(hoardingCurrentData?.expiry_date)}}</p></div>
                                    </div> -->
                                    <div class="form-group row">
                                        <div class="col-4"><p>Expiry</p></div>
                                        <div class="col-8">
                                            <p class="" [ngStyle]="{'color':getColor(hoardingCurrentData?.expiryDays)}"><b>{{hoardingCurrentData?.expiryDays}} Days</b></p>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div *ngIf="isEdit">
                                <div [formGroup]="form"  class="form-horizontal" >
                                    <div class="row m-0 p-0 w-100">
                                        <div class="col-md-12 m-0 p-0">
                                            <div class="row m-0 p-2">
                                                <div class="input-group col-md-12 m-0 p-0">
                                                    <div class="input-group-prepend">
                                                      <div class="input-group-text">Hoarding Name</div>
                                                    </div>
                                                    <input type="text" class="form-control"  formControlName="name" placeholder="" required>
                                                </div>
                                            </div> 
                                            <div class="row m-0 p-2">
                                              <div class="input-group col-md-12 m-0 p-0">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Area</div>
                                                  </div>
                                                  <input (keypress)="omit_special_char($event)"  type="text" class="form-control"  formControlName="area" placeholder="" required>
                                              </div>
                                            </div> 
            
                                            <div class="row m-0 p-0">
                                              <div class="input-group col-md-12 m-0 p-2">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Asset Type</div>
                                                  </div>
                                                  <select class="custom-select-dialog round"  formControlName="asset_type_id"  required>
                                                    <option value="">Select Asset</option>
                                                    <option *ngFor="let data of AssetsDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                  </select>
                                              </div>
                                            </div>
                                            
                                            <div class="row m-0 p-0">
                                            
                                              <div class="input-group col-md-12 m-0 p-2">
                                                <div class="input-group-prepend">
                                                  <div class="input-group-text">Creative</div>     
                                                </div>   
                                                 <select class="custom-select-dialog round"  formControlName="creative_id"  required>
                                                  <option value="">Select Creative</option>
                                                  <option *ngFor="let data of CreativeDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                </select>
                                               </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                              <div class="input-group col-md-12 m-0 p-2">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Vendor</div>
                                                  </div>
                                                  <select class="custom-select-dialog round" formControlName="vendor_id" required>
                                                    <option value="">Select Vendor</option>
                                                    <option *ngFor="let data of VendorDataLists" [ngValue]="data.id">{{data.name}}</option>
                                                  </select>
                                              </div>
                                            </div>
                                            <div class="row m-0 p-0">
                                              <div class="input-group col-md-6 m-0 p-2">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Width</div>
                                                  </div>
                                                  <input type="number" class="form-control"  formControlName="size_w" placeholder="" (change)="onWidthChange()" required>
                                              </div>
                                              <div class="input-group col-md-6 m-0 p-2">
                                                <div class="input-group-prepend">
                                                  <div class="input-group-text">Height</div>
                                                </div>
                                                <input type="number" class="form-control"  formControlName="size_h" placeholder="" (change)="onHeightChange()" required>
                                               </div>
                                            </div>   
                                            <div class="row m-0 p-0">
                                              <div class="input-group col-md-6 m-0 p-2">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Sq. Feet</div>
                                                  </div>
                                                  <input type="number" class="form-control"  formControlName="square_feet" placeholder="" required disabled>
                                              </div>
                                              <div class="input-group col-md-6 m-0 p-2">
                                                <div class="input-group-prepend">
                                                  <div class="input-group-text">Cost (&#8377;)</div>
                                                </div>
                                                <input type="number" class="form-control"  formControlName="cost" placeholder="" required>
                                               </div>
                                            </div>
                                            <div class="row m-0 p-2">
                                                <div class="input-group col-md-12 m-0 p-0">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Particulars</div>
                                                  </div>
                                                  <input type="text" class="form-control"  formControlName="particulars" placeholder="" required>
                                                </div>
                                              </div> 
                                              <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                      <div class="input-group-text">Installation Date</div>
                                                    </div>
                                                    <input class="form-control" matInput formControlName="install_date" (dateChange)="startDateClicked($event)" 
                                                              [matDatepicker]="picker1" placeholder="Choose a date">
                                                              <mat-datepicker-toggle matSuffix [for]="picker1" #startDateToggle></mat-datepicker-toggle>
                                                              <mat-datepicker #picker1></mat-datepicker>
                                                </div>

                                                
                                              </div>
                                              <div class="row m-0 p-0">
                                                <div class="input-group col-md-12 m-0 p-2">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Expiry Date</div>
                                                  </div>
                                                  <input class="form-control" matInput [min]="form.controls['install_date'].value" formControlName="expiry_date" (dateChange)="endDateClicked($event)" [matDatepicker]="picker2"
                                                       placeholder="Choose a date">
                                                      <mat-datepicker-toggle matSuffix [for]="picker2" #endDateToggle></mat-datepicker-toggle>
                                                      <mat-datepicker #picker2></mat-datepicker>
                                                 </div>
                                              </div>
                                            <div class="row m-0 p-2">
                                                <div class="input-group col-md-12 m-0 p-0">
                                                  <label class="label-header">Hoarding Image:</label>
                                                  <div class="uploader">
                                      
                                                    <input id="file-upload" type="file" name="fileUpload" accept="image/*" (change)="onFileChange($event)"/>
                                      
                                                    <label for="file-upload" id="file-drag">
                                                      <img [src]="imageSrc" *ngIf="imageSrc" onerror="this.src='/assets/grt.svg'" id="file-image">
                                                      <div id="start" *ngIf="!imageSrc">
                                                        <i class="fa fa-download" aria-hidden="true"></i>
                                                        <div class="label-header">Select a Picture</div>
                                                      </div>
                                                    </label>
                                                  </div>


                                  
                                                </div>
                                            </div>
                                            <div class="row m-0 p-2">
                                                <div class="input-group col-md-12 m-0 p-0">
                                                    <div class="input-group-prepend">
                                                      <div class="input-group-text">Address</div>
                                                    </div>
                                                    <input type="text" class="form-control"  formControlName="address" placeholder="" required>
                                                </div>
                                              </div> 
                                  
                                              <!-- <div class="row m-0 p-0">
                                                <div class="col-md-12 m-0 mb-1">
                                                      <div class="form-group agm-search">
                                                        <label></label> 
                                                        <input style="display:none" type="text" class="form-control" (keydown.enter)="$event.preventDefault()" placeholder="Search Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
                                                      </div>
                                                      <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" #agmMap>
                                                        <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                                                          (dragEnd)="markerDragEnd($event)"></agm-marker>
                                                      </agm-map>
                                                </div>   
                                                <div class="input-group col-md-6 m-0 p-2">
                                                    <div class="input-group-prepend">
                                                      <div class="input-group-text">Latitude</div>
                                                    </div>
                                                    <input type="number" class="form-control"  formControlName="lat" placeholder="" required disabled>
                                                </div>
                                                <div class="input-group col-md-6 m-0 p-2">
                                                  <div class="input-group-prepend">
                                                    <div class="input-group-text">Longitude</div>
                                                  </div>
                                                  <input type="number" class="form-control"  formControlName="lang" placeholder="" required disabled>
                                                 </div> 
                                              </div>-->
                                
                                              <div class="col-lg-12 d-flex justify-content-center detail-buttons p-4" *ngIf="is_Admin_User">
                                                <button type="button" class="btn btn-danger mr-2" (click)="discontinue()">Discontinue</button>
                                                <button type="button" class="btn btn-success mr-2" (click)="onHoardingSingleUpdate()">Save Changes</button>
                                                <!-- <button type="button" class="btn btn-dark" (click)="onHoardingSingleModify()">Modify</button> -->
                                              </div>

                                              <div class="col-lg-12 d-flex justify-content-center detail-buttons p-4" *ngIf="!is_Admin_User">
                                                <button type="button" class="btn btn-danger mr-2" (click)="requestEmail(0)">Damaged</button>
                                                <button type="button" class="btn btn-success mr-2" (click)="requestEmail(1)">Replacement</button>
                                              </div>
                                              
                                        </div>  
                                    </div>  
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
       
    </div>
  </div>  
  <div  class="row m-0 p-1 w-100" *ngIf="nSubModule==4">
    <div class="col-lg-12 m-0 p-1">
         <app-modifyhoarding (messageEvent)="receiveMessage($event)" [selectedHoardings]="sortedselectedHoardings"></app-modifyhoarding> 
    </div>
  </div>
